import { Reveal } from './Reveal'

export function InnerHero({ eyebrow, title, description }) {
  return (
    <section className="inner-hero">
      <div className="container-wide inner-hero-grid">
        <Reveal>
          <p className="eyebrow">{eyebrow}</p>
          <h1 className="display-title">{title}</h1>
        </Reveal>
        <Reveal className="inner-hero-aside" delay={0.12}>
          <p>{description}</p>
        </Reveal>
      </div>
    </section>
  )
}
